// extracted by mini-css-extract-plugin
export var linkText = "_mm-0";